module.exports = __webpack_public_path__ + "img/Carton.3ea692d1.png";